<template>
    <div>
        <card-header title="Edit Certification" icon="fa-pencil"/>

        <card-body>
            <certification-form :certification="certification"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteCertification"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Certification</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!certification.title"
                    >
                        <i class="fas fa-check mr-2"></i>Save Certifications
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import CertificationForm from "@/cards/certifications/CertificationForm";

    import {client as http} from '../../http_client';

    export default {
        components: {CertificationForm, SeparatorListItem, SubheaderListItem, CardListItem, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                certification: {components: []},
                confirmDelete: false,
                dirty: null,
            };
        },
        methods: {
            loadCertification: function() {
                this.$emit('loading', true);
                http.get('certs/' + this.props.certificationId, {force: true}).then(response => {
                    this.certification = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                this.$emit('loading', true);
                http.put('certs/' + this.props.certificationId, this.certification, {force: true}).then(response => {
                    this.$reloadCard('certifications');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            deleteCertification() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);
                    http.delete('certs/' + this.props.certificationId).then(response => {
                        this.$reloadCard('certifications');
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.certificationId': function() {
                this.dirty = null;
                this.loadCertification();
            },
            'certification': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this certification? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadCertification();
        }
    };
</script>
